import { render, staticRenderFns } from "./fee-revenue.vue?vue&type=template&id=5d05fd97"
import script from "./fee-revenue.vue?vue&type=script&lang=js"
export * from "./fee-revenue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports